import { serverURL } from "../utils";

let headers = {
  "Content-Type": "application/json",
};

export const getSettings = async () => {
  const response = await fetch(`${serverURL()}/configuration`, {
    method: "GET",
    headers,
  });
  const settings = await response.json();
  return settings;
};
